/* eslint-disable jira/filename-case */
import { useEffect } from 'react';

/**
 * This component is used for testing HOTFIX process in production env, so it does not have any UI.
 * @tutorial: https://hello.atlassian.net/wiki/spaces/afm/pages/5708595111/Create+a+hotfix+release+playground.
 */
export const HotfixTesting = (): null => {
	useEffect(() => {
		// we will increase this number to test HOTFIX process
		const hotfixNumber = 'hot-0000';

		// eslint-disable-next-line no-console
		console.log('magma-hotfix-testing is enabled. HOTFIX number: ', hotfixNumber);
	}, []);

	return null;
};
